module.exports = __webpack_public_path__ + "media/polar-vortex.a571e1b0.mp3";